import { useEffect } from 'react';
import Cookies from 'js-cookie';

// // UTILITES
// import store from '@/utility/store';

const STORE_SHOWN_PREFIX_KEY = 'shownExitIntent';

export default function useShowExitIntent({ id, onShow, timeout = 1000 }) {
  useEffect(() => {
    let mounted = true;
    const storeKey = `${STORE_SHOWN_PREFIX_KEY}-${id}`;

    const isShownIntent = Cookies.get(storeKey);

    function onMouseOut(e) {
      const shouldShowExitIntent = mounted && !e.toElement && !e.relatedTarget && e.clientY < 10;

      if (shouldShowExitIntent) {
        onShow();

        Cookies.set(storeKey, true, { expires: 30 });

        document.removeEventListener('mouseout', onMouseOut);
      }
    }

    if (!isShownIntent) {
      setTimeout(() => {
        document.addEventListener('mouseout', onMouseOut);
      }, timeout);
    }

    return () => {
      mounted = false;
      document.removeEventListener('mouseout', onMouseOut);
    };
  }, []);

  return null;
}
